export function brandGetEnoughCredits(brand) {
  const minimalCreditToLock = brand.minimalCreditToLock == undefined ? -2000 : brand.minimalCreditToLock;
  return brand.credit >= minimalCreditToLock;
}
